import { Pipe, PipeTransform } from '@angular/core';
import { BaseItemHelpersService } from 'src/app/services/base-item-helpers/base-item-helpers.service';
import { TimeTrackingTypes } from 'src/app/model/enum/cpl-time-tracking-type.enum';

@Pipe({
    name: 'timeTrackingType'
})
export class TimeTrackingTypePipe implements PipeTransform {
    constructor(private baseItemHelpersService: BaseItemHelpersService) {}

    transform(value: TimeTrackingTypes | undefined | null): string {
        return this.baseItemHelpersService.getTimeTrackingTypeLabel(value);
    }

}
